export class Genero{
    public id_genero_pk:Number;
    public genero:String;
    constructor(){
        //this is intentional
    }
}